var React = require('react');

function FacebookW (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M646.2,0H37.8C16.9,0,0,16.9,0,37.8v608.4c0,20.9,16.9,37.8,37.8,37.8h327.5V419.1h-89.2V315.8h89.2v-76.1\n\tc0-88.3,53.9-136.4,132.8-136.4c37.7,0,70.2,2.8,79.6,4.1v92.3l-54.6,0c-42.8,0-51.2,20.4-51.2,50.3v65.9h102.2l-13.3,103.2h-88.9\n\tv264.9h174.3c20.9,0,37.8-16.9,37.8-37.8V37.8C683.9,16.9,667,0,646.2,0z","key":1})]);
}

FacebookW.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 683.9 683.9","style":{"enableBackground":"new 0 0 683.9 683.9"},"xmlSpace":"preserve"};

module.exports = FacebookW;

FacebookW.default = FacebookW;
